import useSportsEvent from '@hooks/useSportsEvent'
import { FunctionComponent, useEffect, useRef } from 'react'
import ToiTeaserComponents from '@components/Teaser/Toi'
import { RelatedSportsMatch } from '../types'
import { LiveEventDataSportTypes } from '@utils/formatters/liveEvent'
import TeaserSportsTileSoccer from './Soccer'
import TeaserSportsTileHockey from './Hockey'

interface TeaserSportsTileProps {
  matchId: RelatedSportsMatch['matchId']
  typeOfSport: RelatedSportsMatch['typeOfSport']
  link: RelatedSportsMatch['link']
  onLoadSuccess: () => void
  onUnmount: () => void
}

const { TileWrapper } = ToiTeaserComponents

const TeaserSportsTile: FunctionComponent<TeaserSportsTileProps> = ({
  matchId,
  typeOfSport,
  link,
  onLoadSuccess,
  onUnmount,
}) => {
  const hasBeenLoadedSuccessfullyRef = useRef<boolean>(false)

  const { data: sportsEventData } = useSportsEvent({
    matchId,
    typeOfSport,
  })

  useEffect(() => {
    if (!hasBeenLoadedSuccessfullyRef.current && sportsEventData) {
      hasBeenLoadedSuccessfullyRef.current = true
      onLoadSuccess()
    }
  }, [onLoadSuccess, sportsEventData])

  useEffect(() => {
    return () => {
      if (hasBeenLoadedSuccessfullyRef.current) {
        onUnmount()
      }
    }
  }, [onUnmount])

  if (!sportsEventData) {
    return null
  }

  return (
    <TileWrapper
      clickableProps={
        link as unknown as { href: string } & Record<string, unknown>
      }>
      {sportsEventData.sportsEventType === LiveEventDataSportTypes.SOCCER && (
        <TeaserSportsTileSoccer formattedData={sportsEventData.formattedData} />
      )}
      {sportsEventData.sportsEventType === LiveEventDataSportTypes.HOCKEY && (
        <TeaserSportsTileHockey formattedData={sportsEventData.formattedData} />
      )}
    </TileWrapper>
  )
}

export default TeaserSportsTile
